import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { mediaCSS } from 'blocks.app/config'
import item from 'blocks.simple/item/item.jcss'
import { textSizes } from 'theme/media'
import { IStyles, palette } from '../../theme'
import { color } from 'theme/tokens/color'

const deviceSettingsStyles: IStyles = {
    wrapper: {
        ...grid.row,
        ...grid.full,
        ...item.white,
        ...grid.noWrap,
        [mediaCSS.tabMini]: {
            ...grid.col,
        },
    },
    sidebar: {
        ...grid.col,
        ...grid.justify,
        ...grid.p_md,
        ...grid.pt_mdPlus,
        ...item.clouds,
        fontSize: textSizes.normalPlus,
        overflowY: 'auto',
        minWidth: 130,
        [mediaCSS.tabMini]: {
            ...grid.col,
            ...grid.pt_mini,
            overflowY: 'initial',
        },
    },
    sidebarTitle: {
        [mediaCSS.tabMini]: {
            ...grid.mb_mdPlus,
        },
        textAlign: 'center',
    },
    content: {
        ...grid.col,
        ...grid.space,
        ...item.rel,
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    },
    titleWrapper: {
        textAlign: 'center',
        width: '100%',
    },
    title: {
        fontSize: 24,
        padding: '0 90px',

        [mediaCSS.desktopL]: {
            padding: 0,

            [mediaCSS.tab]: {
                fontSize: 20,

                [mediaCSS.tabMini]: {
                    fontSize: 16,
                },
            },
        },
    },
    buttons: {
        flex: 'none',
        paddingLeft: '34px',
        paddingBottom: '34px',
        paddingTop: 14,
        background: '#FFFFFF',
        zIndex: 10001,
        ...grid.row,
        [mediaCSS.tab]: {
            ...grid.center,
            paddingLeft: '14px',
            paddingRight: '14px',
        },
    },
    pinCodeWrapper: {
        ...grid.col,
        ...grid.w20,
        marginBottom: 20,
        [mediaCSS.tabMini]: {
            ...grid.w60,
        },
        ...grid.mt_mdPlus,
    },
    syncContentWrapper: {
        ...grid.w40,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    switchWrapper: {
        display: 'flex',
        paddingBottom: 20,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    exhibitionModeContentWrapper: {
        ...grid.w100,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    row: {
        ...grid.fullWidth,
        ...grid.mt_mdPlus,
    },
    positionWrapper: {
        ...grid.row,
        ...grid.fullWidth,
    },
    positionContent: {
        ...grid.col,
        ...grid.w25,
        '&:first-child': {
            ...grid.pr_mini,
        },
        '&:last-child': {
            ...grid.pl_mini,
        },
        [mediaCSS.tab]: {
            ...grid.w45,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
            '&:first-child': {
                ...grid.p_none,
            },
            '&:last-child': {
                ...grid.p_none,
            },
        },
    },
    topPanel: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        flex: 'none',
        padding: '32px 32px 24px 32px',

        [mediaCSS.desktopL]: {
            display: 'block',
            position: 'static',
        },
    },
    gapBottom: {
        marginBottom: 12,
    },
    backButton: {
        position: 'absolute',
        fontSize: 18,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',

        [mediaCSS.desktopL]: {
            position: 'static',
            marginBottom: 14,
        },

        span: {
            marginLeft: 16,
        },
    },
    deviceNameColor: {
        color: palette.brandBlue,
    },
    containerInner: {
        display: 'flex',
        flex: '1 1 auto',
        minHeight: 0,
        padding: '0 32px',

        [mediaCSS.tab]: {
            padding: '0 16px',
        },
    },
    deviceSettings__inner: {
        flex: '1 1 auto',
        minHeight: 0,
        backgroundColor: color.bgWhiteSecondary,
        padding: 10,
        borderRadius: 12,
        overflow: 'auto',

        '& .dropdown_bottomContent': {
            position: 'relative',
            paddingBottom: 14,
        },
        '& .dropdown_topContent': {
            position: 'static',
        },
    },
    deviceSettings__inputWrapper_type_width: {
        ...grid.row,
        ...grid.fullWidth,
        ...grid.mb_mdPlus,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    deviceSettings__inputWrapper_type_speedLimit: {
        ...grid.col,
        ...grid.w25,
        [mediaCSS.tabMini]: {
            ...grid.w60,
        },
    },
    hint: {
        color: color.fontDarkMedium,
        marginTop: 8,
    },
    deviceSettings__input_type_contentDownloadType: {
        ...grid.mr_md,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    deviceSettings__inputWrapper_type_netDiskAddress: {
        ...grid.mt_mdPlus,
        [mediaCSS.tabMini]: {
            ...grid.mt_none,
        },
    },
    collapseBorder: {
        background: '#FFFFFF',
        borderRadius: 8,
        marginBottom: 10,
        border: `1px solid ${color.borderDarkPrimary}`,
    },
    dropdownWrapper: {
        ...grid.w25,
        [mediaCSS.tab]: {
            ...grid.w50,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
}

addStyles(deviceSettingsStyles)
export default deviceSettingsStyles
